import { SOURCE_SYNC_FIELD } from "constants/invoiceSourceSync";
import {
  InvoiceSourceSync,
  SourceSyncChange,
} from "types/Models/invoiceSourceSync";

// Earlier fields matter more to the books, so they are listed first
const FIELD_PRIORITY: string[] = [
  SOURCE_SYNC_FIELD.DELETED,
  SOURCE_SYNC_FIELD.VOIDED,
  SOURCE_SYNC_FIELD.AMOUNT,
  SOURCE_SYNC_FIELD.TAX_AMOUNT,
  SOURCE_SYNC_FIELD.INVOICE_DATE,
  SOURCE_SYNC_FIELD.DUE_DATE,
  SOURCE_SYNC_FIELD.LINE_ITEMS,
];

const fieldRank = (change: SourceSyncChange) => {
  const rank = FIELD_PRIORITY.indexOf(change.field);
  return rank === -1 ? FIELD_PRIORITY.length : rank;
};

// Changes ordered by how much they matter to the books
export const sortSourceChanges = (
  sourceSync: InvoiceSourceSync
): SourceSyncChange[] =>
  [...sourceSync.changes].sort((a, b) => fieldRank(a) - fieldRank(b));
